import React from "react";
import "./style.scss";
import { useGetAboutBannerQuery } from "../../../services/AboutAPI";
import Loader from "../fullPageLoader"

function Index() {
  const { data, error, isLoading } = useGetAboutBannerQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  // Assuming 'data' contains the banners for different pages
  const contactBanner = data?.data?.find(
    (item) => item.page_name === "Contact Us"
  );

  return (
    <div
      className="contact"
      style={{
        backgroundImage: `url(${contactBanner?.banner_image})`, // Set dynamic background image
        backgroundSize: "cover", // Make sure the background image covers the section
      }}
    >
      <section className="contact-banner">
      <div className="banner-overlay"></div>
        <div className="container">
          <div className="banner-heading">
            <h1>Contact Us</h1>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Index;
